module.exports = __webpack_public_path__ + "static/media/postgresql.0bf66b03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/postgresql.png
// module id = 169
// module chunks = 0